module.exports = __webpack_public_path__ + "img/A3-7-plan.eaae6d2d.png";